import { ApplicationInsights } from "@microsoft/1ds-analytics-web-js";

//// https://microsoft.sharepoint.com/teams/MarTechPortal/SitePages/website-tools/oneds/get-started-1DS.aspx

const analytics: ApplicationInsights = new ApplicationInsights();
const config = {
    instrumentationKey: "19e355beb26a401a8b883a8eaa0f73c3-27f3a6d9-e449-4691-9427-247287063478-7011",
    channelConfiguration: {
        // Post channel configuration
        eventsLimitInMem: 5000
    },
    propertyConfiguration: {
        // Properties Plugin configuration
        userAgent: "Custom User Agent"
    },
    webAnalyticsConfiguration: {
        // Web Analytics Plugin configuration
        autoCapture: {
            scroll: true,
            pageView: true,
            onLoad: true,
            onUnload: true,
            click: true,
            resize: true,
            jsError: true
        }
    }
};
export const oneDsAnalystic = () => {
    //Initialize SDK
    analytics.initialize(config, []);
};
